import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import { GET_DATA_SOURCES } from "../../../queries";
import Sidebar2 from "../../Sidebar2";
import { TitleSource } from "../teleporters/Title";
import RegisterSettingsForm from "./Settings/RegisterSettingsForm";
import SettingsProfile from "./Settings/SettingsProfile";
import SettingsList from "./Settings/SettingsList";

const DataSettings = (props:any) => {
    let orgId = props.currentUser.orgId;
    
    const [showSidebar, setShowSidebar] = useState<boolean>(false);
    const [selectedSource, setselectedSource] = useState<any>(null);
    const [sources, setSources] = useState<any>([]);
    const [showCreateSource, setShowCreateSource] = useState<boolean>(false);

    useEffect(() => {
        loadSources();
    }, []);

    const loadSources = () => {
        var data = {
            org_id: orgId
        };
        props.client.query({
            query: GET_DATA_SOURCES,
            variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            setSources(transform(result.data));
        });
    }

    const transform = (data: any) => {
        let orgSources = data.syncarto_app_data_source;

        return orgSources.map((item: any) => {
            return {
                title: item.title,
                min_date: item.min_date,
                max_date: item.max_date,
                collection_id: item.collection_id,
                id: item.id
            }
        });
    }

    const onSelectedSourceId = (sourceId:any) => {
        console.log("onSelectedSourceId > sourceId", sourceId)
        setShowCreateSource(false);
        setselectedSource(sourceId);
        setShowSidebar(true);
    }

    const onSidebarHide = (sourceId:any) => {
        setShowSidebar(false);
    }

    const shouldRefreshSources = () => {
        loadSources();
    }

    const loadFormOptions = () => {
        const optionsFor_data_source_type_id = [
                    {"id":null,"name":"None"},
                    {"id":1,"name":"STAC Tiles"},
                    {"id":2,"name":"Raster Tiles XYZ"},
                    {"id":3,"name":"Vector Tiles"}
                ];  
        // TODO: Write query to make this dynamic          
        const optionsFor_public_data_catalog_id = [
                    {"id":null,"catalog_description":"None"},
                    {"id":1,"catalog_description":"NAIP Imagery"}
                ]; 
        // Might not have a HASHURA table            
        const optionsFor_stac_query_prefix = [ 
                    {"id":"collection","name":"collection"},
                    {"id":"eo:constellation","name":"eo:constellation"}
                ];           
        // Might not have a HASHURA table 
        const optionsFor_date_display_resolution = [ 
                    {"id":"day","name":"day"},
                    {"id":"year","name":"year"}
                ];
        const formOptions = {
            "optionsFor_data_source_type_id": optionsFor_data_source_type_id,
            "optionsFor_public_data_catalog_id": optionsFor_public_data_catalog_id,
            "optionsFor_stac_query_prefix": optionsFor_stac_query_prefix,
            "optionsFor_date_display_resolution": optionsFor_date_display_resolution,
        }
        return formOptions;
    }

    const onShowCreateSource = (e:any) => {
        e.preventDefault();
        setselectedSource(null);
        setShowCreateSource(true);
        setShowSidebar(true);
    }
    let formOptions = loadFormOptions();
    return (
        <div className="m-2-syncarto m-4">
            <TitleSource><h4 className="m-0 mt-1">Data - Catalogs</h4></TitleSource>  
 
            <div>
                <SettingsList orgId={orgId} sources={sources} onSelectedSourceId={onSelectedSourceId} {...props}></SettingsList>
                {<Button 
                    variant="primary"
                    onClick={onShowCreateSource}>
                        Create Catalog
                </Button>} 
            </div>  
            {<Sidebar2 width={550} show={showSidebar} onHide={onSidebarHide} >
                {selectedSource && <SettingsProfile orgId={orgId} sourceId={selectedSource} shouldRefreshSources={shouldRefreshSources} formOptions={formOptions} {...props}></SettingsProfile>}
                {showCreateSource && <RegisterSettingsForm orgId={orgId} shouldRefreshSources={shouldRefreshSources} formOptions={formOptions} {...props}></RegisterSettingsForm>}
            </Sidebar2>}
        </div>
    );
}

export default DataSettings;